<div class="fullcontainer">
  @if (this.error) { <div class="alert alert-danger">{{ this.error }}</div> }
  @if (this.success) { <div class="alert alert-success">{{ this.success }}</div> }
  <div class='sheet'>
    <h1 class='header'>
      {{ this.isNew ? 'New Delivery Note' : 'Delivery Note ' + this.note.noteNumber }}
      @if (!this.isNew) { <span class='badge {{ this.statusBadges[this.note.status] }}' style='font-size:0.9rem;vertical-align:middle'>{{ this.statusLabels[this.note.status] }}</span> }
    </h1>

    @if (this.loading) {
      <p>Loading…</p>
    } @else {
      @if (!this.isNew) {
        <div class='actionBar'>
          @if (this.note.status === 'draft') {
            <button class='btn btn-primary' type='button' [disabled]='this.busy' (click)='this.act("ready")'><i class='fas fa-clipboard-list'></i> Ready to pick</button>&nbsp;
          }
          @if (this.note.status === 'ready' && !this.pickedAny) {
            <button class='btn btn-secondary' type='button' [disabled]='this.busy' (click)='this.act("draft")'><i class='fas fa-undo'></i> Back to draft</button>&nbsp;
          }
          @if (this.note.status === 'ready' || this.note.status === 'part_picked') {
            <button class='btn btn-info' type='button' [routerLink]='["/picking-slips", this.note.id]'><i class='fas fa-clipboard-check'></i> Pick</button>&nbsp;
          }
          @if ((this.note.status === 'part_picked' || this.note.status === 'picked')) {
            <button class='btn btn-success' type='button' [disabled]='this.busy' (click)='this.act("despatch")'><i class='fas fa-shipping-fast'></i> Despatch</button>&nbsp;
          }
          <button class='btn btn-secondary' type='button' (click)='this.print("delivery-note")'><i class='fas fa-file-pdf'></i> Print delivery note</button>&nbsp;
          @if (this.note.status !== 'draft' && this.note.status !== 'cancelled') {
            <button class='btn btn-secondary' type='button' (click)='this.print("picking-slip")'><i class='fas fa-file-pdf'></i> Print picking slip</button>&nbsp;
          }
          @if ((this.note.status === 'draft' || this.note.status === 'ready') && !this.pickedAny) {
            <button class='btn btn-danger' type='button' [disabled]='this.busy' (click)='this.act("cancel")'><i class='fas fa-ban'></i> Cancel note</button>
          }
        </div>
        <br />
      }

      <form (ngSubmit)='this.save()'>
        <app-tabs>
          <app-tab title='Main Details'>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Type</label>
                <select class='form-control' name='noteType' [(ngModel)]='this.note.noteType' [disabled]='!this.editable'>
                  <option value='customer_stock'>{{ this.typeLabels.customer_stock }} – their own goods, no prices</option>
                  <option value='sale'>{{ this.typeLabels.sale }} – our products, priced</option>
                </select>
              </div>
              <div class="form-group col-md-4">
                <label>Customer *</label>
                <ng-select name='accountId' [(ngModel)]='this.note.accountId' [disabled]='!this.editable' (change)='this.onAccountChange()'
                  [class.is-invalid]='this.tried && !this.note.accountId' placeholder='Choose the customer'>
                  @for (a of this.accounts; track a.id) { <ng-option [value]='a.id'>{{ a.name }}</ng-option> }
                </ng-select>
              </div>
              <div class="form-group col-md-4">
                <label>Required date</label>
                <input type='date' class='form-control' name='requiredDate' [(ngModel)]='this.note.requiredDate' [disabled]='!this.editable'>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Customer ref / PO</label>
                <input type='text' class='form-control' name='customerRef' maxlength='100' [(ngModel)]='this.note.customerRef' [disabled]='!this.editable'>
              </div>
              @if (this.isSale) {
                <div class="form-group col-md-4">
                  <label>VAT %</label>
                  <input type='number' min='0' max='100' class='form-control' name='vatRate' [(ngModel)]='this.note.vatRate' [disabled]='!this.editable'>
                </div>
              }
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>Notes</label>
                <textarea class='form-control' name='notes' rows='2' [(ngModel)]='this.note.notes' [disabled]='!this.editable'></textarea>
              </div>
            </div>

            <h2 class='header'>Products</h2>
            @if (this.editable) {
              <button class='btn btn-secondary' type='button' (click)='this.addLine()'><i class='fas fa-plus'></i> Add line</button>
              @if (!this.isSale && this.note.accountId && !this.productChoices.length) {
                <span class='text-muted'>&nbsp; This customer has no products of their own yet.</span>
              }
              <br /><br />
            }
            @if (this.note.lines.length > 0) {
              <table class="table">
                <thead>
                  <th>Product</th>
                  <th style='width:9rem'>Qty</th>
                  @if (!this.editable) { <th>Picked</th><th>Outstanding</th> }
                  @if (this.isSale) { <th style='width:10rem'>Unit price (&pound;)</th><th>Total (&pound;)</th> }
                  @if (this.editable) { <th></th> }
                </thead>
                <tbody>
                  @for (line of this.note.lines; track $index; let i = $index) {
                    <tr>
                      <td>
                        @if (this.editable) {
                          <ng-select [name]='"product" + i' [attr.name]='"product" + i' [(ngModel)]='line.productId' (change)='this.onProductChange(line)'
                            [class.is-invalid]='this.tried && !line.productId' placeholder='Choose a product'>
                            @for (p of this.productChoices; track p.id) { <ng-option [value]='p.id'>{{ p.name }}{{ p.sku ? ' (' + p.sku + ')' : '' }}</ng-option> }
                          </ng-select>
                        } @else {
                          {{ line.description || line.productName }} <small class='text-muted'>{{ line.sku }}</small>
                          @for (k of this.picksFor(line.id); track k.id) {
                            <div class='text-muted small'>Picked {{ k.qty }} from {{ k.locationCode }}{{ k.batchNumber ? ', batch ' + k.batchNumber : '' }}</div>
                          }
                        }
                      </td>
                      <td>
                        @if (this.editable) {
                          <input type='number' min='0' step='any' class='form-control' [name]='"qty" + i' [attr.name]='"qty" + i' [(ngModel)]='line.qty' [class.is-invalid]='this.tried && !(line.qty > 0)'>
                        } @else { {{ line.qty }} }
                      </td>
                      @if (!this.editable) {
                        <td>{{ line.qtyPicked }}</td>
                        <td>{{ line.outstanding }}</td>
                      }
                      @if (this.isSale) {
                        <td>
                          @if (this.editable) {
                            <input type='number' min='0' step='0.01' class='form-control' [name]='"price" + i' [attr.name]='"price" + i' [(ngModel)]='line.unitPrice'>
                          } @else { {{ line.unitPrice | number:'1.2-2' }} }
                        </td>
                        <td>{{ this.lineTotal(line) | number:'1.2-2' }}</td>
                      }
                      @if (this.editable) {
                        <td><button class='btn btn-danger' type='button' (click)='this.removeLine(i)'><i class='fas fa-trash'></i></button></td>
                      }
                    </tr>
                  }
                </tbody>
              </table>
            }
            @if (this.isSale) {
              <table class='table' style='width:100%;'>
                <tbody>
                  <tr><td colspan='3'><strong>Net total</strong></td><td>&pound;{{ this.net | number:'1.2-2' }}</td></tr>
                  <tr><td colspan='3'><strong>VAT total &#64; {{ this.note.vatRate }}%</strong></td><td>&pound;{{ this.vat | number:'1.2-2' }}</td></tr>
                  <tr><td colspan='3'><strong>Gross total</strong></td><td>&pound;{{ (this.net + this.vat) | number:'1.2-2' }}</td></tr>
                </tbody>
              </table>
            }
          </app-tab>

          <app-tab title='Delivery Address'>
            @if (this.isNew) { <p class='text-muted'>Leave blank to use the customer's shipping address.</p> }
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Deliver to (name)</label>
                <input type='text' class='form-control' name='deliveryName' [(ngModel)]='this.note.deliveryName' [disabled]='!this.editable'>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label>Address line 1</label>
                <input type='text' class='form-control' name='deliveryAddress1' [(ngModel)]='this.note.deliveryAddress1' [disabled]='!this.editable'>
              </div>
              <div class="form-group col-md-6">
                <label>Address line 2</label>
                <input type='text' class='form-control' name='deliveryAddress2' [(ngModel)]='this.note.deliveryAddress2' [disabled]='!this.editable'>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-4">
                <label>Town / city</label>
                <input type='text' class='form-control' name='deliveryCity' [(ngModel)]='this.note.deliveryCity' [disabled]='!this.editable'>
              </div>
              <div class="form-group col-md-4">
                <label>Postcode</label>
                <input type='text' class='form-control' name='deliveryPostCode' [(ngModel)]='this.note.deliveryPostCode' [disabled]='!this.editable'>
              </div>
              <div class="form-group col-md-4">
                <label>Country</label>
                <input type='text' class='form-control' name='deliveryCountry' [(ngModel)]='this.note.deliveryCountry' [disabled]='!this.editable'>
              </div>
            </div>
          </app-tab>
        </app-tabs>

        @if (this.editable) {
          <button type="submit" class="btn btn-success" [disabled]='this.busy'>Save</button>&nbsp;
        }
        <button type="button" class="btn btn-danger" routerLink='/delivery-notes'>{{ this.editable ? 'Cancel' : 'Back' }}</button>
      </form>
    }
  </div>
</div>
